import { captureError } from '@/shared/lib/errors/capture';

const REGISTER_FLOW_TOKEN_KEY = 'register_flow_allowed';

export function setRegisterFlowToken(): void {
  try {
    sessionStorage.setItem(REGISTER_FLOW_TOKEN_KEY, '1');
  } catch (error) {
    captureError(error, {
      component: 'RegisterFlowGuard',
      action: 'set',
      severity: 'info',
      skipPostHog: true,
    });
  }
}

export function hasRegisterFlowToken(): boolean {
  try {
    return sessionStorage.getItem(REGISTER_FLOW_TOKEN_KEY) === '1';
  } catch (error) {
    captureError(error, {
      component: 'RegisterFlowGuard',
      action: 'get',
      severity: 'info',
      skipPostHog: true,
    });
    return true; // graceful degradation: allow access if storage unavailable
  }
}

export function clearRegisterFlowToken(): void {
  try {
    sessionStorage.removeItem(REGISTER_FLOW_TOKEN_KEY);
  } catch (error) {
    captureError(error, {
      component: 'RegisterFlowGuard',
      action: 'clear',
      severity: 'info',
      skipPostHog: true,
    });
  }
}

const EMAIL_REGISTRATION_FLAG_KEY = 'email_just_registered';

export function setEmailRegistrationFlag(): void {
  try {
    sessionStorage.setItem(EMAIL_REGISTRATION_FLAG_KEY, '1');
  } catch (error) {
    captureError(error, {
      component: 'RegisterFlowGuard',
      action: 'set-email-flag',
      severity: 'info',
      skipPostHog: true,
    });
  }
}

export function consumeEmailRegistrationFlag(): boolean {
  try {
    const value = sessionStorage.getItem(EMAIL_REGISTRATION_FLAG_KEY) === '1';
    sessionStorage.removeItem(EMAIL_REGISTRATION_FLAG_KEY);
    return value;
  } catch (error) {
    captureError(error, {
      component: 'RegisterFlowGuard',
      action: 'consume-email-flag',
      severity: 'info',
      skipPostHog: true,
    });
    return false;
  }
}
